module.exports = __webpack_public_path__ + "img/masterclass-sesi-3.e6d9c02f.png";